(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }

    connectedCallback(){
      this.header = document.querySelector('.shopify-section-header');
      this.background = this.getAttribute('data-background');
      this.applyColorScheme = this.getAttribute('data-color-scheme');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.headerHeight = this.header.getBoundingClientRect().height;
      this.headerWrap = this.header.querySelector('.header-wrapper');
      this.isFrosted = this.headerWrap.dataset.frosted;
      this.isSticky = this.headerWrap.dataset.sticky;
      this.menuInline = this.header.querySelector('.list-menu--inline');
      this.activeMenuItem = this.header.querySelector('.header__active-menu-item');
      this.listMenuItems = this.header.querySelectorAll('.header__inline-menu .list-menu__item-list');

      this.openingMenu = false;
      this.closingMenu = false;
      this.isFadeOutTransition = false;
      this.listMenuItems.forEach((summary)=>summary.addEventListener('mouseenter', this.handleMouseEnter.bind(this)));
      this.listMenuItems.forEach((summary)=>summary.addEventListener('mouseleave', this.handleMouseleave.bind(this)));
      this.listMenuItems.forEach((summary)=>summary.addEventListener('click', this.handleClick.bind(this)));

      if (this.isSticky){
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }

      const searchHomeField = document.getElementById('search-home-field');
      let headerHeight = this.header.getBoundingClientRect().height;
      if (searchHomeField){
        headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
        if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')){
          searchHomeField.classList.add('search-home--transparent');
        }
      }
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');

      let prevHeight = 0;
      const resizeObserver = new ResizeObserver((entries)=>{
        for (const entry of entries){
          if (entry.contentBoxSize){
            const height = entry.contentBoxSize?.[0].blockSize;
            if (typeof height === 'number' && height !== prevHeight){
              prevHeight = height;
              let headerHeight = this.header.getBoundingClientRect().height;
              if (searchHomeField){
                headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
              }
              document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
            }
          }
        }
      });

      resizeObserver.observe(this.header);
      this.setupTransparency();
      if (Shopify.designMode){
        document.addEventListener('shopify:section:load', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:unload', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:reorder', this.setupTransparency.bind(this));
      }
    }

    disconnectedCallback(){
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver(){
      let observer = new IntersectionObserver((entries, observer)=>{
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom){
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom){
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal){
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(()=>{ this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top){
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide(){
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (!this.applyColorScheme){ this.header.classList.add(this.background); }
      this.closeMenuDisclosure(); this.closeSearchModal();
    }

    reveal(){
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      if (!this.applyColorScheme){ this.header.classList.add(this.background); }
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset(){
      this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate');
      if (!this.applyColorScheme){ this.header.classList.remove(this.background); }
    }

    handleClick(event){
      const summaryElm = event.target;
      const menuItem = summaryElm.closest('.list-menu__item-list');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      this.header.classList.add(this.background, 'is-filled');
      setTimeout(()=>{ detailsElement.classList.add('sub-menu-opening'); });
    }

    handleMouseEnter(event){
      const menuItem = event.target;
      const menuItemSpan = menuItem.querySelector('.header__menu-item');
      const detailsElement = menuItem.querySelector('.details--list-menu');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm)=>{ elm.classList.remove('header__active-menu-item'); });
      if (menuItemSpan) menuItemSpan.classList.add('header__active-menu-item');
      if (!detailsElement) return;

      if (this.closingMenu && detailsElement.getAttribute('open') && !this.isFadeOutTransition){
        window.clearTimeout(this.timeoutClose); this.closingMenu = false;
      }
      if (detailsElement.getAttribute('open') && !this.isFadeOutTransition) return;

      window.clearTimeout(this.timeoutOpen);
      this.openingMenu = true;
      this.timeoutOpen = setTimeout(()=>{
        this.openingMenu = false;
        this.openSubMenu(detailsElement);
      },300);
    }

    openSubMenu(detailsElement){
      detailsElement.setAttribute('open', true);
      if (this.isFrosted) this.headerWrap.classList.remove('frosted-header-glass');
      this.header.classList.add(this.background, 'is-filled');
      this.closeMenuLocalization();
      setTimeout(()=>{ detailsElement.classList.add('sub-menu-opening'); });
    }

    handleMouseleave(event){
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm)=>{ elm.classList.remove('header__active-menu-item'); });

      if (!detailsElement) return;

      if (this.openingMenu && !detailsElement.getAttribute('open')){
        window.clearTimeout(this.timeoutOpen); this.openingMenu = false;
      }
      if (!detailsElement.getAttribute('open')) return;

      this.closingMenu = true;
      this.timeoutClose = setTimeout(()=>{
        this.closingMenu = false;
        this.closeSubMenu(detailsElement);
      },300);
    }

    closeSubMenu(detailsElement){
      if (this.isFrosted) this.headerWrap.classList.add('frosted-header-glass');
      this.header.classList.remove('is-filled');
      if (!this.header.classList.contains('animate')){ this.header.classList.remove(this.background); }

      detailsElement.classList.remove('sub-menu-opening');
      this.isFadeOutTransition = true;

      detailsElement.addEventListener('transitionend', ()=>{
        detailsElement.removeAttribute('open');
        this.isFadeOutTransition = false;
      }, { once:true });
    }

    closeMenuDisclosure(){
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure)=>disclosure.close());
    }

    closeMenuLocalization(){
      this.headerLocalization = this.headerLocalization || this.header.querySelectorAll('localization-form');
      this.headerLocalization.forEach((disclosure)=>disclosure.hidePanel());
    }

    closeSearchModal(){
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) { /* this.searchModal.close(false); */ }
    }

    /* FIXED: make top transparent when the first section allows it */
    setupTransparency(){
      const canBeTransparent = document.querySelector('.shopify-section:first-child [allow-transparent-header]');
      const sectionEl = this.header; // .shopify-section-header

      if (canBeTransparent){
        sectionEl.classList.remove(this.background);
        sectionEl.removeAttribute('style');
        this.setAttribute('data-transparency', 'true');
      } else {
        if (!this.applyColorScheme){ sectionEl.classList.add(this.background); }
        this.removeAttribute('data-transparency');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
